module.exports = __webpack_public_path__ + "static/MT_Benefit-07.4a1f84b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-07.png
// module id = 1467
// module chunks = 169858455373905